module.exports = __webpack_public_path__ + "static/taste-0c097dc91877cbdfbff502e1870da70e.jpg";